module.exports = __webpack_public_path__ + "static/finovate-spring-2015-9c5221920566118972467a9292ef97f7.png";